import React, { Component } from "react";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { observer } from "mobx-react";
import { queryGetCaseCloseAggregateCount } from "Apollo";
import { CaseHistoryStore } from "Store";
import Tab from "module-case-management/list-panel/header/Tab";

export default graphql(queryGetCaseCloseAggregateCount)(
  observer(
    class Header extends Component {
      render() {
        const store = CaseHistoryStore;
        const { data: { getCaseCloseAggregateCount: count } } = this.props;
        return (
          <Wrapper>
            <Tab
              name="CASE HISTORY"
              selected
              total={count || 0}
              sortAsc={store.sortAsc}
              onSortClick={() => {
                store.sortAsc = !store.sortAsc;
              }}
            />
          </Wrapper>
        );
      }
    }
  )
);

const Wrapper = styled.div`
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  display: flex;
  
`;



// WEBPACK FOOTER //
// ./src/module-case-history/list-panel/HeaderWithStoreQuery.js